import styles from './Academy.module.css';
import ScrollReveal from '../Ui/ScrollReveal';

const curriculumData = [
    {
        day: 'Day 1',
        modules: [
            {
                moduleNum: '# Module 1',
                title: '컬러 마인드 코칭의 이해',
                items: [
                    '컬러 마인드 코칭의 정의',
                    '컬러 마인드 코칭의 철학'
                ]
            },
            {
                moduleNum: '# Module 2',
                title: '감성컬러의 이해',
                items: [
                    '감성컬러의 정의',
                    '색채 대한 이해 : Hue & Tone'
                ]
            },
            {
                moduleNum: '# Module 3',
                title: 'HUE&TONE 102 감성컬러',
                items: [
                    '특허로 102 감성컬러카드 이해',
                    '감성컬러별 행동사의 이해와 의미'
                ]
            },
            {
                moduleNum: '# Module 4',
                title: '102 감성컬러카드 실습',
                items: [
                    '컬러 마인드 코칭을 위한 102 감성컬러카드 활용 실습',
                ]
            }
        ]
    },
    {
        day: 'Day 2',
        modules: [
            {
                moduleNum: '# Module 1',
                title: '컬러 마인드 코칭스킬',
                items: [
                    '라포형성하기 & 경청하기',
                    '질문하기 & 피드백'
                ]
            },
            {
                moduleNum: '# Module 2',
                title: '컬러 마인드 코칭 애티튜드',
                items: [
                    '코처로서 음성적 이미지',
                    '비즈니스 매너와 코칭 사전준비'
                ]
            },
            {
                moduleNum: '# Module 3',
                title: '5P 마인드 코칭 대화모델',
                items: [
                    '5P 코칭 대화모델 프로세스',
                    '5P 단계별 체크 포인트와 대화모델 활용'
                ]
            },
            {
                moduleNum: '# Module 4',
                title: '컬러 마인드 코칭 프로세스',
                items: [
                    '5P 대화모델 적용 코칭 프로세스 습득 ',
                    '컬러 마인드 코칭 준비방법과 평가표'
                ]
            }
        ]
    }
];
function Academy() {
    return (
        <div className={styles.academy}>
            <ScrollReveal>
                <section className={styles.section01}>
                <div className={styles.imgbox}>
                    <img
                        src="/image/education-section01-01.jpg"
                        alt="컬러 이미지"
                    />
                </div>
                <div className={styles.infoBox}>
                    <div className={styles.infoHeader}>
                        <p className={styles.subtitle}>
                            academy education
                        </p>
                        <p className={styles.koTitle}>
                            전문가 양성을 위한 아카데미교육
                        </p>
                    </div>
                    <div className={styles.infoDetail}>
                        <div className={styles.infoDesc}>
                            <span>
                                감성색채 전문가 양성을 위한 아카데미교육은 퍼스널 컬러 컨설팅, 컬러 테라피, 이미지 컨설팅 등 색채 분야의 전문가를 양성하기 위한 교육 프로그램입니다.
                            </span>
                        </div>
                        <ul className={styles.infoList}>
                            <li>
                                <span className={styles.pointcolor}>·</span>
                                <span>감성색채 전문가 2급 자격과정</span>
                            </li>
                            <li>
                                <span className={styles.pointcolor}>·</span>
                                <span>
                                    감성색채 전문가 1급 자격과정
                                </span>
                            </li>
                            <li>
                                <span className={styles.pointcolor}>·</span>
                                <span>컬러 마인드 코치</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            </ScrollReveal>
            <ScrollReveal>
                <section className={styles.section02}>
                <div className={styles.titleWrap}>
                    <p className={styles.subtitle}> academy education </p>
                    <h2 className={styles.title}>
                        감성색채전문가 2급 자격과정
                    </h2>
                </div>
                <div className={styles.line}></div>
                <div className={styles.targetSubtitleWrap}>
                    <p className={styles.targetSubtitle}>
                        <span className={styles.pointcolor}>✓</span>
                        <span>색채 관련 기초 컬러 전문 지식을 습득하여 전문가의 기본 자질을 갖춘다.</span>
                    </p>
                    <p className={styles.targetSubtitle}>
                        <span className={styles.pointcolor}>✓</span>
                        <span> 색채의 구분 및 활용도를 파악하여 실제 적용의 기반을 잡는다.</span>
                    </p>
                </div>
                <div className={styles.tableWrap}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>과목</th>
                                <th>주요내용</th>
                                <th>시간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>감성색채학 개론</td>
                                <td>
                                    <ul>
                                        <li>감성색채학 이론</li>
                                        <li>색채학의 기초와 역사</li>
                                        <li>색채학과 뇌과학의 접점과 이해</li>
                                        <li>KS 표준 색상환(한국표준 색상환)</li>
                                    </ul>
                                </td>
                                <td>
                                    3H
                                </td>
                            </tr>
                            <tr>
                                <td>감성색채학 개론</td>
                                <td>
                                    <ul>
                                        <li>감성색채의 심리적 접근법과 이해</li>
                                        <li>7가지 컬러의 긍정/부정 의미와 에너지</li>
                                        <li>감성색채 소통과 심리적 활용법</li>
                                    </ul>
                                </td>
                                <td>
                                    3H
                                </td>
                            </tr>
                            <tr>
                                <td>감성 배색 트레이닝</td>
                                <td>
                                    <ul>
                                        <li>KS색조(tone)학습</li>
                                        <li>이미지스케일에 따른 색채실습
                                            <br />
                                            - 이미지스케일 구조와 개념이해 / 감성배색원리
                                            <br />
                                            - 22가지 감성형용사 키워드 이해 / 22가지 감성배색실습
                                        </li>
                                        <li>감성색채 포트폴리오 제작 발표</li>
                                    </ul>
                                </td>
                                <td>
                                    6H
                                </td>
                            </tr>
                            <tr>
                                <td>감성색채의 활용</td>
                                <td>
                                    <ul>
                                        <li>자신의 감성색채 포트폴리오 제작
                                            <br />
                                            - 프로젝트 선정, 컨셉이미지, 컬러컨셉, 컬러적용 등
                                        </li>
                                        <li>개인 포트폴리오 발표</li>
                                        <li>자격증 시험</li>
                                    </ul>
                                </td>
                                <td>
                                    3H
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            </ScrollReveal>
            <ScrollReveal>
                <section className={styles.section03}>
                <div className={styles.titleWrap}>
                    <p className={styles.subtitle}>academy education</p>
                    <h2 className={styles.title}>
                        감성색채전문가 1급 자격과정
                    </h2>
                </div>
                <div className={styles.line}></div>
                <div className={styles.targetSubtitleWrap}>
                    <p className={styles.targetSubtitle}>
                        <span className={styles.pointcolor}>✓</span>
                        <span>컬러가 필요한 곳으 감성에 맞춰 컬러 지식을 적용할 수 있도록 의,식,주에 컬러를 적용할 줄 아는 컬러 전문가를 양성한다.</span>
                    </p>
                    <p className={styles.targetSubtitle}>
                        <span className={styles.pointcolor}>✓</span>
                        <span>색채를 통해 부가가치를 향상 시키고 컨설팅 및 교육이 가능한 인재를 양성한다.</span>
                    </p>
                </div>
                <div className={styles.tableWrap}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>과목</th>
                                <th>주요내용</th>
                                <th>시간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>스타일과 감성색채</td>
                                <td>
                                    <ul>
                                        <li>퍼스널컬러의 개념과 활용</li>
                                        <li>4개절 분류 개념</li>
                                        <li>진단 시스템 설명 및 셀프 진단</li>
                                        <li>얼굴 이미지와 5가지 패션, 뷰티스타일</li>
                                    </ul>
                                </td>
                                <td>
                                    5H
                                </td>
                            </tr>
                            <tr>
                                <td>푸드와 감성색채</td>
                                <td>
                                    <ul>
                                        <li>컬러푸드의 이해</li>
                                        <li>5가지 맛에 따른 감성배색</li>
                                        <li>맛과 건강을 위한 오행푸드 이해와 적용</li>
                                    </ul>
                                </td>
                                <td>
                                    5H
                                </td>
                            </tr>
                            <tr>
                                <td>공간과 감성색채</td>
                                <td>
                                    <ul>
                                        <li>공간컬러 감성배색 기법</li>
                                        <li>9가지 이미지 공간 스타일</li>
                                        <li>공간 색채심리 활용법</li>
                                    </ul>
                                </td>
                                <td>
                                    5H
                                </td>
                            </tr>
                            <tr>
                                <td>교수 기법</td>
                                <td>
                                    <ul>
                                        <li>교안작성법</li>
                                        <li>컬러 강의 기법</li>
                                        <li>프레젠테이션 기법 및 시범 강의 준비</li>
                                    </ul>
                                </td>
                                <td>
                                    5H
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            </ScrollReveal>
            <ScrollReveal>
                <section className={styles.section04}>
                <div className={styles.imgbox}>
                    <img
                        src="/image/education-section04-01.png"
                        alt="컬러 이미지"
                    />
                </div>
                <div className={styles.infoBox}>
                    <div className={styles.infoHeader}>
                        <p className={styles.subtitle}>
                            academy education
                        </p>
                        <p className={styles.koTitle}>
                            컬러 마인드 코치
                        </p>
                    </div>
                    <div className={styles.infoDetail}>
                        <div className={styles.infoDesc}>
                            <span>
                            2021년에 특허받은 "휴앤톤 기반 컬러테라피 상담시스템"을 기반으로 코칭의 철학이해와 코칭스킬을 익힐 수 있습니다.
                            </span>
                            <span>
                            7만명 통계에 의해 나눠진 감성키워드가 배치된 감성컬러카드를 활용하며 특허 이후 수년간의 임상을 거쳐 컬러로 마인드케어를 돕는 코칭 프로그램으로 업그레이드 되었습니다.
                            </span>
                            <span>
                            5P 마인드 코칭 대화모델을 통해 컬러를 매개체로 심도있는 코칭법을 이론과 실습으로 교육합니다. 
                            </span>
                        </div>
                        <ul className={styles.infoList}>
                            <li className={styles.infoListTitle}>대상</li>
                            <li>
                                <span className={styles.pointcolor}>✓</span>
                                <span>상담과 코칭에 효과적인 매개체가 필요하신 분</span>
                            </li>
                            <li>
                                <span className={styles.pointcolor}>✓</span>
                                <span>
                                    감성을 잘 다루어줄 수 있는 코칭법을 익히고 싶은 분
                                </span>
                            </li>
                            <li>
                                <span className={styles.pointcolor}>✓</span>
                                <span>컬러 또는 코칭을 처음 접하시는 분</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            </ScrollReveal>
            <ScrollReveal>
                <section className={styles.section05}>
                <div className={styles.titleWrap}>
                    <p className={styles.subtitle}>curriculum</p>
                    <h2 className={styles.title}>
                        컬러 마인드 코치 커리큘럼
                    </h2>
                    <div className={styles.line}></div>
                </div>
                <div className={styles.curriculumWrap}>
                    {curriculumData.map((dayData, dayIndex) => (
                        <div key={dayIndex} className={styles.curriculumDay}>
                            <div className={styles.curriculumDayHeader}>
                                <h3 className={styles.curriculumDayTitle}>{dayData.day}</h3>
                            </div>
                            <div className={styles.curriculumModules}>
                                {dayData.modules.map((module, moduleIndex) => (
                                    <div key={moduleIndex} className={styles.curriculumModule}>
                                        <h4 className={styles.curriculumModuleNum}>{module.moduleNum}</h4>
                                        <h5 className={styles.curriculumModuleTitle}>{module.title}</h5>
                                        <ul className={styles.curriculumModuleList}>
                                            {module.items.map((item, itemIndex) => (
                                                <li key={itemIndex}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </section>
            </ScrollReveal>
        </div> 
    );
}

export default Academy;

